import { Injectable } from '@angular/core';
import { GlobalIntakeData } from '../models/globalintakedata';
import { GlobalIntakeResponse } from '../models/globalintakeresponse';
import { Session } from './session.service';
import { Http } from 'src/app/shared/services/http.service';
import { LogService } from './log.service';
import { BaseComponent } from 'src/app/shared';

@Injectable({
  providedIn: 'root',
})
export class IntakeService extends BaseComponent {
  constructor(
    private http: Http,
    private session: Session,
    public logService: LogService
  ) {
    super();
  }

  async getSmartlyUrl(globalIntakeData?: GlobalIntakeData) {
    this.FeatureLogging('ReportNewClaim', 'Report New Claim', 'Submit');

    await this.session.loadUser();
    if (!globalIntakeData) {
      globalIntakeData = new GlobalIntakeData({
        giftCard: false,
        timeZone: this.session.user.timezone,
      });
    }
    return await this.http.post<GlobalIntakeResponse>(
      '/api/intake/BeginGlobalIntake',
      globalIntakeData
    );
  }
}
